const o = function(e, c) {
  let r = {};
  if (e)
    if (e.PreferenceService)
      ({ PreferenceService: r } = e);
    else
      return e.PreferenceService = r, c(r);
  return r;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(e) {
    let c = {
      locale: "",
      currency: ""
    };
    const r = () => c, n = (t) => {
      c = Object.assign(c, t);
    };
    return e.getPreferences = r, e.setPreferences = n, e;
  }
);
export {
  o as s
};
//# sourceMappingURL=PreferenceService-ebb3b9de.mjs.map
